import React, { useState } from "react";
import { View, StyleSheet, Pressable, ActivityIndicator } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { colors, radii, spacing } from "../../../../styles/design-system";

export interface TabData {
  key: string;
  title: string;
}

interface StudentProfileTabsProps {
  tabData: TabData[];
  activeTab: string;
  onTabChange: (tabKey: string) => void;
  loading?: boolean;
}

const StudentProfileTabs: React.FC<StudentProfileTabsProps> = ({
  tabData,
  activeTab,
  onTabChange,
  loading = false,
}) => {
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);

  return (
    <View style={styles.container}>
      {tabData.map((tab: TabData) => {
        const isActive = activeTab === tab.key;
        const isHovered = hoveredTab === tab.key;

        return (
          <Pressable
            key={tab.key}
            style={[styles.tab, isActive && styles.activeTab, isHovered && !isActive && styles.hoverTab]}
            onPress={() => onTabChange(tab.key)}
            onHoverIn={() => setHoveredTab(tab.key)}
            onHoverOut={() => setHoveredTab(null)}
            disabled={loading}>
            <CustomText
              text={tab.title}
              size="s"
              style={[styles.tabText, isActive && styles.activeTabText]}
              useTranslationText={false}
            />
          </Pressable>
        );
      })}
      {loading && (
        <View style={styles.loaderContainer}>
          <ActivityIndicator size="small" color={colors.blue[500]} />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    backgroundColor: colors.white,
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderRadius: radii.lg,
    borderWidth: 1,
    borderColor: colors.grey[200],
    alignSelf: "flex-start",
    alignItems: "center",
  },
  tab: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    marginHorizontal: 4,
    borderRadius: 12,
  },
  activeTab: {
    backgroundColor: "#EEF2FF",
  },
  hoverTab: {
    backgroundColor: colors.grey[100],
  },
  tabText: {
    color: colors.grey[600],
  },
  activeTabText: {
    color: "#4338CA",
  },
  loaderContainer: {
    paddingHorizontal: spacing.md,
  },
});

export default StudentProfileTabs;
